import { Type } from "class-transformer";
import { EnterpriseOutDTO } from "./enterprise.out.dto";

export class EnterprisePaginatedOutDTO {
  @Type(() => EnterpriseOutDTO)
  enterprises!: EnterpriseOutDTO[];

  total!: number;
}
